module.exports = "pegasus_template/assets/background-patterns/subtle-white-mini-waves.png";